import React, { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { authAPI } from '../../services/api';
import { useAuth } from '../../contexts/AuthContext';

const AuthCallback = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { refreshAuth } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // CRITICAL: Set flag synchronously to prevent race conditions
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processSession = async () => {
      try {
        // Extract session_id from URL fragment
        const hash = location.hash;
        const params = new URLSearchParams(hash.substring(1));
        const sessionId = params.get('session_id');

        if (!sessionId) {
          throw new Error('No session_id in URL');
        }

        // Exchange session_id for user session
        const response = await authAPI.googleSession(sessionId);
        const userData = response.data;

        // Refresh auth context
        await refreshAuth();

        // Navigate to dashboard with user data
        navigate('/dashboard', { state: { user: userData }, replace: true });
      } catch (error) {
        console.error('Auth callback error:', error);
        navigate('/login', { state: { error: 'Authentication failed' }, replace: true });
      }
    };

    processSession();
  }, [location, navigate, refreshAuth]);

  return (
    <div className="min-h-screen bg-brand-bg flex items-center justify-center">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-violet-600 mx-auto mb-4"></div>
        <p className="text-zinc-400">Completing authentication...</p>
      </div>
    </div>
  );
};

export default AuthCallback;
